function googleMapsApiKey() {
  const meta = document.querySelector('meta[name="google-maps-api-key"]')
  return meta ? meta.content : ''
}

export function loadGoogleMapsApi() {
  if (window.google && window.google.maps) {
    return Promise.resolve(window.google.maps)
  }

  if (window.CollectionneurGoogleMapsPromise) {
    return window.CollectionneurGoogleMapsPromise
  }

  window.CollectionneurGoogleMapsPromise = new Promise((resolve, reject) => {
    const callbackName = '__collectionneurGoogleMapsReady'
    const script = document.createElement('script')
    const params = [
      ['key', googleMapsApiKey()],
      ['v', 'weekly'],
      ['loading', 'async'],
      ['callback', callbackName],
    ]

    window[callbackName] = () => {
      delete window[callbackName]
      resolve(window.google.maps)
    }

    script.async = true
    script.defer = true
    script.onerror = () => reject(new Error('Failed to load Google Maps JavaScript API'))
    script.src = `https://maps.googleapis.com/maps/api/js?${params
      .map((param) => `${encodeURIComponent(param[0])}=${encodeURIComponent(param[1])}`)
      .join('&')}`

    document.head.appendChild(script)
  })

  return window.CollectionneurGoogleMapsPromise
}
